import React from 'react';
import { Typography } from '@mui/material';

import SocialMedia from 'components/social-media';

const Footer = () => (
  <footer>
    <SocialMedia />
    <Typography textAlign='center' variant='subtitle2' pb={5}>
      &copy; Built by Mohammed Amin Painter.
    </Typography>
  </footer>
);

export default Footer;
